// Resolves the absolute URL for an API call. `apiName` selects the backend
// ('api' = PostgREST, 'fastapi' = the FastAPI service). The local-db runner
// sets REACT_APP_USE_LOCAL_DB at frontend startup; the regular frontend runner
// deliberately keeps using dev PostgREST through its proxy.
const useLocalDb = process.env.REACT_APP_USE_LOCAL_DB === 'true';
const localPostgrestUrl = (process.env.REACT_APP_LOCAL_POSTGREST_URL || 'http://localhost:3001')
    .replace(/\/+$/, '');

export const baseURL = (apiName, endpoint) => {
    if (window.location.hostname === 'localhost' && apiName === 'fastapi') return `http://localhost:8082/${endpoint}`;
    if (window.location.hostname === 'localhost' && apiName === 'api' && useLocalDb) {
        return `${localPostgrestUrl}/${endpoint}`;
    }
    if (window.location.hostname === 'localhost') return `https://dev.stables.palomino.consulting/${apiName}/${endpoint}`;
    return `${window.location.protocol}//${window.location.hostname}/${apiName}/${endpoint}`;
};
